export default __webpack_public_path__ + "static/media/doorDash.e373ad45.png";